import { AccountUpdater as r } from "./account-updator.js";
import { ArrowUp as o } from "./arrow-up.js";
import { ArrowSmall as m } from "./arrow-small.js";
import { BookMark as i } from "./bookmark.js";
import { Close as p } from "./close.js";
import { CheckMark as t } from "./checkmark.js";
import { FastCheckout as e } from "./fast-checkout.js";
import { Queue as f } from "./queue.js";
import { ShoppingCart as s } from "./shopping-cart.js";
import { User as U } from "./user.js";
import { UserBusiness as l } from "./user-business.js";
import { UserAdmin as a } from "./user-admin.js";
import { UserAdminPin as c } from "./user-admin-pin.js";
import { UserDeveloper as n } from "./user-developer.js";
import { UserPencil as k } from "./user-pencil.js";
import { UserStar as C } from "./user-star.js";
import { Users2 as h } from "./users-2.js";
import { Users3 as u } from "./users-3.js";
import { Recycle as S } from "./recycle.js";
import { Users4 as d } from "./users-4.js";
import { Users5 as g } from "./users-5.js";
import { Users9 as A } from "./users-9.js";
import { ZoomIn as B } from "./zoom-in.js";
import { ZoomOut as P } from "./zoom-out.js";
import { UserBackground as w } from "./user-background.js";
import { UserHeart as F } from "./user-heart.js";
import { UserMinus as y } from "./user-minus.js";
import { UserPlus as D } from "./user-plus.js";
import { UserClose as M } from "./user-close.js";
import { UserLock as b } from "./user-lock.js";
import { UsersBag as x } from "./users-bag.js";
import { UsersBaggage as R } from "./users-baggage.js";
import { UserGraph as Z } from "./user-graph.js";
import { Search2 as v } from "./search2.js";
import { ShopperBag as G } from "./shopper-bag.js";
import { ShopperRisk as H } from "./shopper-risk.js";
import { ShopperBagAction as I } from "./shopper-bag-action.js";
import { Support as L } from "./support.js";
import { Filter as O } from "./filter.js";
import { Play as Q } from "./play.js";
import { PlayFilled as T } from "./play-filled.js";
import { StarCircle as j } from "./star-circle.js";
import { StarCircleFilled as q } from "./star-circle-filled.js";
import { CheckboxDouble as z } from "./checkbox-double.js";
import { CheckmarkCircle as E } from "./checkmark-circle.js";
import { CheckmarkCircleFilled as J } from "./checkmark-circle-filled.js";
import { TwoArrowsDown as K } from "./two-arrows-down.js";
const Tr = {
  AccountUpdater: r,
  ArrowUp: o,
  ArrowSmall: m,
  BookMark: i,
  Close: p,
  CheckMark: t,
  FastCheckout: e,
  Queue: f,
  ShoppingCart: s,
  User: U,
  UserBusiness: l,
  UserAdmin: a,
  UserAdminPin: c,
  UserDeveloper: n,
  UserPencil: k,
  UserStar: C,
  Users2: h,
  Users3: u,
  Recycle: S,
  Users4: d,
  Users5: g,
  Users9: A,
  ZoomIn: B,
  ZoomOut: P,
  UserBackground: w,
  UserHeart: F,
  UserMinus: y,
  UserPlus: D,
  UserClose: M,
  UserLock: b,
  UsersBag: x,
  UsersBaggage: R,
  UserGraph: Z,
  Search2: v,
  ShopperBag: G,
  ShopperRisk: H,
  ShopperBagAction: I,
  Support: L,
  Filter: O,
  Play: Q,
  PlayFilled: T,
  StarCircle: j,
  StarCircleFilled: q,
  CheckboxDouble: z,
  CheckmarkCircle: E,
  CheckmarkCircleFilled: J,
  TwoArrowsDown: K
};
export {
  Tr as UiAndPeople
};
